import { render, staticRenderFns } from "./ImportParentCompanyModal.vue?vue&type=template&id=045175be&scoped=true"
import script from "./ImportParentCompanyModal.vue?vue&type=script&lang=js"
export * from "./ImportParentCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./ImportParentCompanyModal.vue?vue&type=style&index=0&id=045175be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045175be",
  null
  
)

export default component.exports